import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import InfoCard from "./InfoCard";
import InfoCardTitle from "./InfoCardTitle";
import _ from "lodash";

export default function MySource({ locationData }) {
  let locationInfo = [];
  _.forEach(locationData, (farmerDatum, key) => {
    if (farmerDatum) {
      locationInfo.push({ title: key, description: farmerDatum });
    }
  });

  return (
    <Box sx={{ marginTop: 2 }} id={`my-source`}>
      <Box sx={{ textAlign: "center" }}>
        <img
          src={`/ViewMySource.jpg`}
          alt={`View My Source`}
          width={300}
          height={76}
        />
      </Box>

      <InfoCard>
        <InfoCardTitle
          image={<img src={`/Source.png`} alt={``} width={30} height={40} />}
          content={
            <>
              {_.map(locationInfo, (locationDatum) => (
                <Typography
                  textAlign={"left"}
                  variant={`caption`}
                  sx={{ display: "block", ml: 2 }}
                >
                  <Typography variant={`caption`}>
                    {locationDatum["title"]} {` `}: {` `}
                    {locationDatum["description"]}
                  </Typography>
                </Typography>
              ))}
            </>
          }
        />

        <Box sx={{ mt: 1, textAlign: "center" }}>
          <img
            src={`https://static.agrostar.in/output/location-maps/${
              locationData[`State`]
            }--${locationData[`District`]}.png`}
            width={300}
            height={320}
            alt={`Location`}
          />
        </Box>
      </InfoCard>
    </Box>
  );
}
